export enum LocalStorageKey {
    ACTIVITY_SCROLL_POSITION_KEY = 'activityScrollPosition',
    LOYALTY_SEARCH_TYPE_KEY = 'activitiesLoyaltySearchType',
    RECENT_CITIES = 'recentCities',
    RECENT_ACTIVITIES = 'recentActivities',
}

export enum SessionStorageKey {
    TOP_ACTIVITIES = 'topActivities',
    SEARCH_OVERLAY = 'activities.search.overlay',
    LANDING_PATH = 'landingPath',
}
